<template>
    <div>
        <!-- Modal Seleção -->
        <div class="modal fade" id="relatorioEditorListaSelecaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecionar</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    ref="pesquisa"
                                    sizing="sm"
                                    icon="fa fa-search fa-fw" 
                                    placeholder="Pesquisar..."
                                    v-model="search"
                                    @input="index = 0"
                                    @onArrowDown="onArrowDown"
                                    @onArrowUp="onArrowUp"
                                    @onEnter="onEnter" />
                            </div>
                        </div>

                        <az-empty-state v-if="!exibicao.length" icon="fa fa-search" msg="Nenhum item identificado" />

                        <div class="list-group">
                            <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between small px-3 py-2" v-for="(item, iix) in exibicao" :key="iix" :class="index === iix ? 'active' : ''"
                                @click="selecionar(item)">
                                <div>{{ item.title }}</div>
                                <div class="text-muted" v-if="false">{{ item.name }}</div>
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../shared/forms/AzInput.vue';
import AzEmptyState from '../util/AzEmptyState.vue';

export default {
    data() {
        return { 
            lista: [], 
            search: '', 
            index: null,
            callback: null, 
        }
    },

    components: { 
        AzInput, 
        AzEmptyState
    },

    computed: { 
        exibicao: function () { 
            if ( !this.lista ) { 
                return []; 
            }

            let reg = this.$util.getregex(this.search);

            return this.lista.filter(item => !this.search || reg.test(JSON.stringify(item)));
        }
    },

    methods: { 
        selecionar (item) { 
            this.callback(item);
            $('#relatorioEditorListaSelecaoModal').modal('hide');
        },

        onArrowDown () {
            if ( this.index === null ) { 
                this.index = 0;
            } else if ( this.index < this.exibicao.length - 1 ) {
                this.index ++;
            }
		},

		onArrowUp () {
			if ( this.index > 0 ) {
				this.index --;
			}
		},

		onEnter () {
            console.log('enter', this.index, this.exibicao[this.index]);
            
            if ( this.index !== null && this.exibicao[this.index] ) {
                this.selecionar(this.exibicao[this.index]);
            }
        },

        abrir (lista, callback = null) { 
            this.search = '';
            this.lista = lista; 
            this.index = null; 
            this.callback = callback;

            $('#relatorioEditorListaSelecaoModal').modal('show');

            setTimeout(() => { 
                if ( this.$refs['pesquisa'] ) { 
                    this.$refs['pesquisa'].$refs.input.focus();
                }
            }, 500);
        }
    }
}
</script>
